import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import Category3 from "./3LevelCategory/Category3";

const MobileSubcategorynew = ({ value,setwdith }) => {
  const { bgColor, textColor } = useSelector((state) => state.theam);
  const [showfullmenu, setshowfullmenu] = useState(false);
  const [activemenu,setactivemenu] = useState(false);
  const nvg = useNavigate();
  const categoryid = value.category_id;
  // console.log("check submenu is here ",value);

  const transfer2 = (value, subcategory,main) => {
    nvg(`/mini/category/${value}/${main} > ${subcategory}/${btoa('none')}`);
  };

  const transfer3 = (value, subcategory,main,subsubcategory) => {
    console.log("check data is here or not",value, subcategory,main,subsubcategory)
    nvg(`/mini/category/${value}/${main} > ${subcategory} > ${subsubcategory}/${btoa('none')}`);
  };

  const transfer = (id,value) => {
    nvg(`/mini/category/${id}/${value}/${btoa('none')}`);
  };

  return (
    <>
    <li className={value.child.length == 0 ? "" : "mega"}>
     <div className="d-flex justify-content-between"> {value.child.length == 0 ? (
       <div  style={{width:'100%'}} className="d-flex align-items-center justify-content-between" onClick={() => {
        setshowfullmenu(!showfullmenu);
      }} > <button
          className="btn dark-menu-item desgin1"
          // style={{ padding: "6px 18px 0px 18px" }}
          style={{ padding: "6px 0px 0px 0px" }}
          onClick={() => {
            transfer(value.category_id,value.category_name);
          }}
          type="button"
        >
          &nbsp; <span onClick={() => {
            transfer(value.category_id,value.category_name);
          }} style={{color:window.location.href.includes(categoryid) ? `#${textColor}` : ''}} className="largefont"> {value.category_name} </span>
        </button>
      <span className="d-flex align-items-center" style={{ position: 'relative', left: '10px',display:value.child.length == 0 ? "none" : '' }} onClick={()=>{setactivemenu(!activemenu);}} ><MdOutlineKeyboardArrowRight /></span>
      </div>

      ) : (
        <div style={{width:'100%'}} className="d-flex align-items-center justify-content-between" onClick={() => {
          setshowfullmenu(!showfullmenu);
        }}>
        <button
          type="button"
          className="btn dark-menu-item desgin1 justshow"
          style={{ padding: "6px 0px 0px 0px" }}
          // style={{ padding: "6px 18px 0px 18px" }}
          onClick={() => {
            setshowfullmenu(!showfullmenu);
          }}
        >
          &nbsp; <span className="largefont" > {value.category_name}</span>
        </button>
        <span className="d-flex align-items-center" style={{ position: 'relative', left: '10px',display:value.child.length == 0 ? "none" : '' }} onClick={()=>{setactivemenu(!activemenu)}} ><MdOutlineKeyboardArrowRight /></span>
        </div>
      )}
     </div>
      {window.location.href.includes(value.category_name) || showfullmenu == true ? (
        value.child.length < 0 ? (
          ""
        ) : (
          <ul
            className="mega-menu "
            // className="mega-menu full-mega-menu "
            style={{ display: "block",padding:"0px 9px" }}
          >
            <div>
              <div className="container">
                <div className="row">
                  {value.child.map((item, index) => (
                    <div className="col mega-box">
                      <div className="link-section">
                        {/* <div className="menu-title">
                         <div className="d-flex justify-content-between"> 
                          <h5 onClick={() => {transfer2(item.id, item.name,value.category_name)}}
                            style={{marginBottom:item.children.length > 0 ? "5px" : '10px',fontWeight: "400",color:decodeURIComponent(window.location.href).includes(item.name) ? `#${textColor}` : ''}}
                          >
                            {item.name}{" "}
                          </h5> <span style={{position:'relative',left:'21px'}}><MdOutlineKeyboardArrowRight /></span> </div>
                          {item.children.length > 0 ?  <ul style={{paddingLeft:'10px',marginBottom:'11px'}}>

{item.children.map((childrenitem, index) => (
  <li>
  <p  onClick={() => {transfer3(childrenitem.id, item.name,value.category_name,childrenitem.name)}} style={{fontSize:'11px',color:decodeURIComponent(window.location.href).includes(childrenitem.name) ? `#${textColor}` : '#444444'}}>{childrenitem.name}</p>
  </li>
))}
</ul> : ''}
                         
                        </div> */}

                        <Category3 transfer2={transfer2} value={value} item={item} transfer3={transfer3} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </ul>
        )
      ) : (
        ""
      )}
    </li>
    
    </>
  );
};

export default MobileSubcategorynew;
